import React from 'react'

const Footer = () =>
    <footer>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="socials">
                    {
                        socials.map((social, i) =>
                            <a
                                key={i}
                                href={social.href}
                                target="_blank"
                                data-track={social.slug + '-ftr'}
                            >
                                <img
                                    src={social.icon}
                                    alt={social.name}
                                    className="socialicon"
                                />
                            </a>
                        )
                    }
                    </div>
                    <p className="legal">
                        <span style={{ fontFamily: 'cursive' }}>&copy; 2019</span> Parlophone Records Limited<br />
                        <a href="https://wminewmedia.com/terms-of-use/" target="_blank">Terms of Use</a> &bull; <a href="https://wminewmedia.com/privacy/" target="_blank">Privacy Policy</a> &bull; <a href="http://www.wminewmedia.com/cookies/" target="_blank">Cookie Policy</a>
                    </p>
                </div>
            </div>
        </div>
    </footer>

export default Footer

const socials = [
    {
        href: 'http://www.instagram.com/therealkano',
        name: 'Instagram',
        slug: 'instagram',
        icon: 'img/instagram.svg'
    },
    {
        href: 'http://www.facebook.com/therealkano',
        name: 'Facebook',
        slug: 'facebook',
        icon: 'img/facebook.svg'
    },
    {
        href: 'http://www.twitter.com/therealkano',
        name: 'Twitter',
        slug: 'twitter',
        icon: 'img/twitter.svg'
    },
    {
        href: 'http://www.youtube.com/user/kano',
        name: 'YouTube',
        slug: 'youtube',
        icon: 'img/youtube.svg'
    },
    {
        href: 'https://open.spotify.com/artist/50nN8IFD4xA67fI4jYbLV4',
        name: 'Spotify',
        slug: 'spotify',
        icon: 'img/spotify.svg'
    },
    {
        href: 'https://music.apple.com/gb/artist/kano/7293994',
        name: 'Apple Music',
        slug: 'apple-music',
        icon: 'img/apple.svg'
    },
    {
        href: 'http://www.soundcloud.com/therealkano',
        name: 'Soundcloud',
        slug: 'soundcloud',
        icon: 'img/soundcloud.svg'
    }
]
